import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output
} from '@angular/core';
import { AbstractControl, UntypedFormControl } from '@angular/forms';

@Component({
  selector: ' aid-input',
  template: `
    <mat-form-field
      class="full-width"
      color="primary"
      [matTooltip]="tooltip"
      [matTooltipDisabled]="!tooltip"
    >
      @if (label && applyPipes) {
        <mat-label>{{ label | translate | sentancecase }}</mat-label>
      }
      @if (label && !applyPipes) {
        <mat-label>{{ label }}</mat-label>
      }
      <div class="aid-layout-row aid-layout-align-start-center">
        @if (prefixIcon) {
          <mat-icon
            [ngClass]="{ 'resize-icon': prefixIcon === 'euro' }"
            matPrefix
            [svgIcon]="prefixIcon"
          ></mat-icon>
        }
        <input
          matInput
          [formControl]="control"
          autocomplete="off"
          placeholder="{{ placeholder | translate }}"
          [type]="type"
          [required]="isRequired"
          data-cy="text-input"
        />
        @if (suffixIcon) {
          <mat-icon
            matSuffix
            [svgIcon]="suffixIcon"
            [ngClass]="{ 'resize-icon': suffixIcon === 'euro' }"
          >
          </mat-icon>
        }
        @if (loading) {
          <mat-spinner class="filter__loading" diameter="16"> </mat-spinner>
        }
      </div>
      @if (control.hasError('required')) {
        <mat-error>
          {{ label || 'this-field' | translate | titlecase }}
          {{ 'is-required' | translate }}
        </mat-error>
      }
      @if (control.hasError('email')) {
        <mat-error>
          {{ 'email-invalid' | translate }}
        </mat-error>
      }
      @if (control.hasError('timeFormat')) {
        <mat-error>
          {{ 'time-format-error' | translate }}
        </mat-error>
      }
      @if (control.hasError('phoneNumberFormat')) {
        <mat-error>
          {{ 'phone-number-format-error' | translate }}
        </mat-error>
      }
      @if (control.hasError('hexColor')) {
        <mat-error>
          {{ 'hex-color-error' | translate }}
        </mat-error>
      }
      @if (control.hasError('maxThreeCharacters')) {
        <mat-error>
          {{ label || 'this-field' | translate | sentancecase }}
          {{ 'abbreviation-3-characters' | translate }}
        </mat-error>
      }
      @if (control.hasError('pattern')) {
        <mat-error>
          {{ 'invalid-format' | translate }}
        </mat-error>
      }

      @for (error of control.errors | keyvalue; track error) {
        <mat-error>
          @if (displayError(error.key)) {
            {{ error.value | translate }}
          }
        </mat-error>
      }

      @if (hint) {
        <mat-hint>{{ hint | translate }}</mat-hint>
      }
    </mat-form-field>
  `,
  styleUrls: ['./input.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class InputComponent implements OnInit {
  @Input() control: UntypedFormControl = new UntypedFormControl();
  @Input() label?: string;
  @Input() placeholder?: string;
  @Input() prefixIcon?: string;
  @Input() suffixIcon?: string;
  @Input() applyPipes = true;
  @Input() type = 'text';
  @Input() loading = false;
  @Input() hint?: string;
  @Input() tooltip: string = '';
  @Output() onChange = new EventEmitter<any>();

  constructor() {}

  ngOnInit() {
    this.control.valueChanges.subscribe(value => {
      this.onChange.emit(value);
    });
  }

  get isRequired(): boolean {
    if (this.control.validator) {
      const validator = this.control.validator({} as AbstractControl);
      if (validator && validator.required) {
        return true;
      }
    }

    return false;
  }

  get errors() {
    return this.control.errors ? this.control.errors : {};
  }

  /**
   * TODO Refactor all the validators to send the error message on control
   * Remove this function when all the custom errors are done
   */
  displayError(error: string): boolean {
    return !(
      error === 'required' ||
      error === 'email' ||
      error === 'timeFormat' ||
      error === 'phoneNumberFormat' ||
      error === 'hexColor' ||
      error === 'maxThreeCharacters' ||
      error === 'pattern'
    );
  }
}
